"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var client_1 = require("@apollo/client");
var react_intl_1 = require("react-intl");
var InitPaymentError_1 = require("../../ErrorPages/InitPaymentError");
var FailedPaymentError_1 = require("../../ErrorPages/FailedPaymentError");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var payment2C2PStyles_1 = require("./payment2C2PStyles");
var cache_1 = require("../../../../../common/graphql/cache");
var JourneyTypes_1 = require("../../../../../../../../common/enum/JourneyTypes");
var Payment2C2P = function (_a) {
    var initError = _a.initError, isPaymentFailed = _a.isPaymentFailed, paymentAmount = _a.paymentAmount;
    var styles = payment2C2PStyles_1.default();
    var intl = react_intl_1.useIntl();
    var userJourney = client_1.useReactiveVar(cache_1.activeJourneyType);
    if (initError) {
        return <InitPaymentError_1.default />;
    }
    if (isPaymentFailed) {
        return <FailedPaymentError_1.default />;
    }
    return (<>
      <core_1.Typography data-test="text:payment:subtitle" variant="subtitle1" className={styles.subtitle}>
        {paymentAmount || userJourney === JourneyTypes_1.JourneyTypes.ORDER_ONLINE ? (<Translation_1.default id="trans__checkout__payment_page__order_online__subtitle" values={{ amount: paymentAmount }}/>) : (<Translation_1.default id="trans__checkout__payment_page__subtitle"/>)}
      </core_1.Typography>
      <core_1.Typography data-test="text:payment:description" variant="subtitle1" className={styles.description}>
        {paymentAmount ? (<Translation_1.default id="trans__checkout__payment_page__order_online__description1" values={{ amount: paymentAmount }}/>) : (<Translation_1.default id="trans__checkout__payment_page__description1"/>)}
      </core_1.Typography>
      <core_1.Typography data-test="text:payment:description2" variant="subtitle1" className={styles.description2}>
        <Translation_1.default id="trans__checkout__payment_page__description2" values={{
        email: (<a className={styles.email} href={"mailto:" + intl.formatMessage({
            id: 'trans__checkout__payment_page__email',
        })}>
                <Translation_1.default id={'trans__checkout__payment_page__email'}/>
              </a>),
    }}/>
      </core_1.Typography>
    </>);
};
exports.default = Payment2C2P;
